export default "__VITE_ASSET__DirlYTTO__"